export default "__VITE_ASSET__d09db9d1__"